import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

function Hero() {
    const { isEnLang } = useLanguage();

    return (
        <section className="hero">
            <div className="hero-overlay">
                <motion.div
                    className="hero-content"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.2 }}
                >
                    <span className="hero-eyebrow">Anzio &amp; Nettuno — Costa Laziale</span>
                    <h1>
                        {isEnLang ? 'Welcome to\nAlma Suite' : 'Benvenuti\nall\'Alma Suite'}
                    </h1>
                    <p>
                        {isEnLang
                            ? 'Hospitality and elegance on the Lazio coast'
                            : 'Accoglienza ed eleganza sulla costa laziale'}
                    </p>
                    <div className="hero-ctas">
                        <a
                            href={`https://wa.me/+393928729907?text=${encodeURIComponent("Salve, vorrei prenotare al B&B Alma Suite. www.almasuitebb.it")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hero-cta primary"
                        >
                            {isEnLang ? 'Book Now' : 'Prenota Ora'}
                        </a>
                        <Link to="/camere" className="hero-cta secondary">
                            {isEnLang ? 'Explore Rooms' : 'Scopri le Camere'}
                        </Link>
                    </div>
                </motion.div>
            </div>

            <div className="hero-booking-strip">
                <div className="hero-booking-strip-inner">
                    <div className="hero-booking-score">
                        <span className="hero-booking-number">9.8</span>
                        <div>
                            <span className="hero-booking-label">
                                {isEnLang ? 'Exceptional' : 'Eccezionale'}
                            </span>
                            <span className="hero-booking-sub">Booking.com</span>
                        </div>
                    </div>
                    <span className="hero-booking-divider" />
                    <p className="hero-booking-text">
                        {isEnLang
                            ? 'One of the best-rated properties in the Anzio & Nettuno area'
                            : 'Una delle strutture meglio valutate nella zona di Anzio e Nettuno'}
                    </p>
                    <a
                        href="https://www.booking.com/hotel/it/alma-suite-bed-and-breakfast.it.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hero-booking-link"
                    >
                        {isEnLang ? 'See reviews' : 'Leggi le recensioni'}
                    </a>
                </div>
            </div>
        </section>
    );
}

export default Hero;
